import React from 'react';
import Phone from 'react-phone-number-input'
import './style.scss'

function PhoneNumberInput({ input: { value, onChange }, meta }) {
  return (
    <Phone value={value} onChange={onChange}/>
  )
}

export default PhoneNumberInput;



// WEBPACK FOOTER //
// ./src/components/PhoneNumberInput/PhoneNumberInput.js